import { useRef } from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CloseIcon from "@mui/icons-material/Close";

export default function ThumbnailPicker({ preview, onFileSelected, onClear, error }) {
  const inputRef = useRef(null);

  return (
    <Stack sx={{ flexShrink: 0 }}>
      <Box sx={{ position: "relative", width: { xs: 48, sm: 60 }, height: { xs: 48, sm: 60 } }}>
        <input
          type="file"
          accept="image/*"
          hidden
          ref={inputRef}
          onChange={(e) => {
            const file = e.target.files[0];
            e.target.value = "";
            if (file) onFileSelected(file);
          }}
        />
        <Box
          onClick={() => inputRef.current?.click()}
          sx={{
            width: "100%",
            height: "100%",
            borderRadius: 1,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "background.default",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            overflow: "hidden",
          }}
        >
          {preview ? (
            <Box component="img" src={preview} alt="" sx={{ width: "100%", height: "100%", objectFit: "contain" }} />
          ) : (
            <AddAPhotoIcon sx={{ color: "text.disabled" }} />
          )}
        </Box>
        {preview && (
          <IconButton
            size="small"
            aria-label="remove photo"
            onClick={onClear}
            sx={{
              position: "absolute",
              top: -8,
              right: -8,
              width: 20,
              height: 20,
              bgcolor: "background.paper",
              border: "1px solid",
              borderColor: "divider",
              "&:hover": { bgcolor: "background.paper" },
            }}
          >
            <CloseIcon sx={{ fontSize: 14 }} />
          </IconButton>
        )}
      </Box>
      {error && (
        <Typography variant="caption" color="error" sx={{ maxWidth: { xs: 48, sm: 60 } }}>
          {error}
        </Typography>
      )}
    </Stack>
  );
}
